import { Typography } from '@mui/material'
import React from 'react'

export const TestSuiteEditDetailsDrawerTitle: React.FC<{ isEdit: boolean }> = ({
  children,
  isEdit
}) => {
  const actionCopy = isEdit ? 'Editing' : 'Adding'

  return (
    <Typography variant="h5">
      {actionCopy} Scenario:{' '}
      <Typography component="em" variant="h5">
        {children}
      </Typography>
    </Typography>
  )
}
